<template>
  <div>
    <!--TODO get rid of this paddingrow please-->
    <v-row v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
           v-style:paddingRight="$valueByBreakpoint($finPadding.right)"
           fluid>
      <v-col>
        <fin-data-table :headers="headers" :mobile-breakpoint="Number.MAX_SAFE_INTEGER" :resolver="[instrument]" hide-default-footer hide-default-header
                        transparent disable-row-hover/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {TablePresets} from "@/components/common/DataTable/DefaultHeaders"
import FinDataTable from "@/components/common/DataTable/FinDataTable"

export default {
  name: 'fin-etf-page-data',
  components: {FinDataTable},
  props: {
    instrument: {

    }
  },
  data: ()=>({
    headers: TablePresets.createEtfProfileBaseDataHeaders()
  })
}
</script>

<style lang="scss" scoped>

</style>
